.actionButtons {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.buttonGroup {
  display: flex;
  gap: 0.5rem;
}
